import { render, staticRenderFns } from "./Representation.vue?vue&type=template&id=0a2908c1&scoped=true"
import script from "./Representation.vue?vue&type=script&lang=js"
export * from "./Representation.vue?vue&type=script&lang=js"
import style0 from "./Representation.vue?vue&type=style&index=0&id=0a2908c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2908c1",
  null
  
)

export default component.exports